module.exports = __webpack_public_path__ + "images/pipelinedeals-product-overview.pdf";